import { Expose, } from 'class-transformer';
import { Utilities } from '../utils/Utilities';

export class ImageFileData {

	private _data: string | null = null;
	@Expose()
	get data(): string | null { return this._data; }
	set data(newImageData: string) {
		this._data = newImageData;
		this._hash = Utilities.hashCode(newImageData);
	}

	@Expose()
	set rawData(unbasedData: string) {
		let baseData: string;
		try {
			baseData = btoa(unbasedData);
		} catch {
			// Contains non-Latin1 characters — encode via TextEncoder → binary string → btoa
			const bytes = new TextEncoder().encode(unbasedData);
			let binary = '';
			bytes.forEach((b) => (binary += String.fromCharCode(b)));
			baseData = btoa(binary);
		}
		this.data = `data:${ this._contentType };base64,${ baseData }`;
	}
	get rawData(): string | null {
		if (!this._data || this._data.length === 0) {
			return null;
		}
		const dataPos = this._data.indexOf('base64');
		if (dataPos < 0) {
			return null;
		}
		const stripped = this._data.substring(dataPos + 7);
		return atob(stripped);
	}

	private _name: string | null = null;
	@Expose()
	get name(): string | null { return this._name; }
	set name(newFilename: string) {
		this._name = newFilename;
		if (newFilename) {
			this._suffix = Utilities.getImageSuffix(newFilename);
		} else {
			this._suffix = null;
		}
	}

	private _contentType: string | null = null;
	@Expose()
	set contentType(newValue: string) {
		this._contentType = newValue;
		if (newValue) {
			const charsetPos = newValue.indexOf('; charset');
			if (charsetPos > 0) {
				this._contentType = newValue.substring(0, charsetPos);
			}
			if (this._contentType === 'application/pdf') {
				this._contentType = 'image/svg+xml';
			}
		}
	}
	get contentType(): string | null {
		return this._contentType;
	}

	private _hash = 0;
	@Expose()
	get hash(): number { return this._hash; }
	set hash(newHash: number) { this._hash = newHash; }

	private _isNew = false;
	@Expose()
	get isNew(): boolean { return this._isNew; }
	set isNew(newIsNew: boolean) { this._isNew = newIsNew; }

	private _size = 0;
	@Expose()
	set size(newValue: number) { this._size = newValue; }
	get size(): number { return this._size; }

	private _suffix: string | null = null;
	@Expose()
	get suffix(): string | null { return this._suffix; }
	set suffix(newExtension: string) { this._suffix = newExtension; }

	private _weburl: string | null = null;
	@Expose()
	get weburl(): string | null { return this._weburl; }
	set weburl(newValue: string) {
		this._weburl = newValue;
		if (newValue) {
			this.name = Utilities.getFilenameFromPath(newValue);
			this._suffix = Utilities.getImageSuffix(this.name);
		} else {
			this._name = null;
			this._suffix = null;
		}
	}

	reset(): void {
		this.name = '';
		this.suffix = '';
		this._weburl = '';
		this._data = null;
	}

	isImageSuffix(): boolean {
		return Utilities.isImageSuffix(this._suffix);
	}

	get hasImage(): boolean {
		return !!this._data && Utilities.hasValidValue(this._data) && this._data.length > 0;
	}
}
